const src = require("/app/src/assets/images/svg/home-active.svg?as-resource");
const img = new String(src);
img.src = src;
img.width = 18;
img.height = 18;
img.toString = function() { return src; };
module.exports = img;